<div class="modal-content">
  <div class="modal-header">
    EDITAR INFORMAÇÕES DA CONVENIÊNCIA
    <img src="./assets/icon_custom/18-p-fechar-b.svg" class="close-btn" (click)="closeModal()">
  </div>
  <div class="modal-body">
    <app-convenience-form [convenienceToEdit]="data.convenience" (convenienceEmitter)="editConvenience($event)"></app-convenience-form>
  </div>
</div>
